"use strict"

import { getLoggedIn, getCartCount } from '../utils/cookies';

export function init() {
    const loginButton = document.querySelector('.global-header__button--login');
    const accountMenu = document.querySelector('.global-header__account-menu');

    if (getLoggedIn()) {
        document.body.classList.add('user-logged-in');
        if (loginButton) loginButton.style.display = 'none';
        if (accountMenu) accountMenu.style.removeProperty('display');
    } else {
        document.body.classList.add('user-logged-out');
        if (loginButton) loginButton.style.removeProperty('display');
        if (accountMenu) accountMenu.style.display = 'none';
    }

    const cartCount = getCartCount();
    if (cartCount > 0) {
        document.querySelectorAll('.js-cart-count').forEach(el => {
            el.textContent = cartCount;
            el.classList.add('is-visible');
        });
    }

    document.querySelectorAll('.js-append-returnurl').forEach(el => {
        const separator = el.dataset.href.indexOf('?') === -1 ? '?' : '&';
        el.setAttribute('href', `${el.dataset.href}${separator}returnurl=${encodeURIComponent(document.location.href)}`);
    });
}